// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"106":"9c8faeef","623":"1cc97578","660":"cc80295e","667":"c11eba20","680":"6dde8aaf","825":"aa3b8fee"}[chunkId] + ".chunk.css";
};